import React from 'react';
import styled from 'astroturf/react';

const Container = styled.div<{
  hoisted?: boolean;
  variant?: 'default' | 'dense';
}>`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  align-self: stretch;
  background: var(--background-white, #fff);
  overflow: hidden;

  &.variant-default {
    border-radius: 0px;
    border: 1px solid var(--stroke-light, #dddde2);
    &.hoisted {
      border: 2px solid $ds-primary-blue-active;
    }
  }

  &.variant-dense {
    padding: 20px 0 16px 0;
    border-radius: 0px;
    border-bottom: 1px solid var(--stroke-medium, #535366);
    &:first-child {
      border-top: 1px solid var(--stroke-medium, #535366);
    }

    &.hoisted {
      padding: 20px 16px 16px 16px;
      border: 1px solid var(--stroke-medium, #535366);
      border-radius: 8px;
    }
  }

  @include for-tablet-sm-up {
    &.variant-default {
      border-radius: var(--corner-radius-radius-md, 8px);
    }

    &:not(.hoisted, .variant-dense) {
      border: 1px solid var(--stroke-light, #dddde2);
    }
  }

  @include breakpoint(small) {
    &.variant-dense {
      padding-left: 16px;
      padding-right: 16px;

      &.hoisted {
        margin: 0 16px;
      }
    }
  }
`;

interface Props {
  className?: string;
  hoisted?: boolean;
  variant?: 'default' | 'dense';
}

const Base: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  children,
  hoisted,
  variant = 'default',
}) => {
  return (
    <Container className={className} hoisted={hoisted} variant={variant}>
      {children}
    </Container>
  );
};

export default Base;
